$(document).on('click', '[data-workpos]', function() {
  const active = $('#search-filters').val();
  const change = $(this).val();
  $('#search-filters').val(change);
  const $wrapper = $(this).closest('form');
  $wrapper.find('[data-workpos]').each(function() {
    const check = $(this);
    if (check.val() === change) {
      check.prop('checked', true);
    } else {
      check.prop('checked', false);
    }
    if (check.val() === active) {
      check.prop('checked', false);
      $('#search-filters').val('');
    }
  });
});

$(document).on('change', '[data-vcard-search-filter]', function() {
  const $wrapper = $(this).parent();
  const data = $(this).serializeArray();
  const searchcontent = $(this).closest('form').find('input[id="id_areasearch"]').val();
  // const active = $wrapper.find('.autocomplete__choice.active,.autocomplete__entry.active');
  $wrapper.find('[data-filter-element]').each(function() {
    const $vcard = $(this);
    let show = '';
    let hasworkposition = false;
    let workposition = false;
    let searchfields = false;
    data.forEach((param) => {
      if (param.name === 'workposition') {
        hasworkposition = true;
        if ($vcard.attr(`data-filter-${param.value}`)) {
          workposition = true;
        }
      }
      if (param.name === 'areas') {
        const areas = param.value.split(',');
        areas.forEach((area) => {
          if ($vcard.attr(`data-area-${area}`)) {
            searchfields = true;
          }
        });
      }
      if (param.name === 'search-area') {
        const area = param.value;
        if (area !== '' && searchcontent !== '' && $vcard.attr(`data-area-${area}`)) {
          searchfields = true;
        }
      }
      if (param.name === 'search-name') {
        const userid = param.value;
        if (userid !== '' && searchcontent !== '' && $vcard.attr(`data-name-${userid}`)) {
          searchfields = true;
        }
      }
    });
    show = false;
    if (hasworkposition && searchcontent !== '') {
      if (workposition === true && searchfields === true) {
        show = true;
      }
    } else if (hasworkposition && workposition) {
      show = true;
    } else if (searchcontent !== '' && searchfields) {
      show = true;
    } else if (!hasworkposition && !searchcontent) {
      show = true;
    }
    $vcard[show ? 'removeClass' : 'addClass']('hide');
  });
});

$(document).on('mouseenter', '.autocomplete__choice,.autocomplete__entry', function() {
  const $wrapper = $(this).closest('.cms-vcard-search');
  const searchtype = $(this).attr('data-autocomplete-type');
  const searchvalue = $(this).attr('data-select-value');
  $wrapper.find('[data-filter-element]').each(function() {
    const $vcard = $(this);
    let show = false;
    if (searchtype === 'searchuser') {
      if (!show && $vcard.attr(`data-name-${searchvalue}`)) {
        $('#search-area').val('');
        $('#search-name').val(searchvalue);
        show = true;
      }
    }
    if (searchtype === 'areas') {
      if (!show && $vcard.attr(`data-area-${searchvalue}`)) {
        $('#search-area').val(searchvalue);
        $('#search-name').val('');
        show = true;
      }
    }
    $vcard[show ? 'removeClass' : 'addClass']('hide');
  });
  // $(this).closest('form').find('input[id="areas"]').value = areas;
});
